import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';
import { ABOUT_HASH_KEYS } from '../../core/constants/infoAndHashConstants';

function AboutHashInfo() {
  const t = useTranslation();
  return ABOUT_HASH_KEYS.map((number) => {
    return (
      <p className='about-hash-code-txt' key={number}>
        {t(TranslationKeys.AboutHashCodeP + number)}
      </p>
    );
  });
}
export default AboutHashInfo;
